var _path, _g, _path2, _g2, _rect, _g3, _path3, _path4, _path5, _rect2, _rect3, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 344,
    viewBox: "0 0 640 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_692_36950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 184,
    width: 238,
    height: 159
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.899 274.152L56.6465 215.811L23.2094 229.151L96.9563 314.769L130.393 301.429L175.905 283.272L226.81 342.371L260.247 329.03L209.342 269.932L238.135 258.444L214.641 231.168L185.848 242.655L135.595 184.314L102.158 197.654L152.411 255.995L106.899 274.152Z",
    fill: "#4671F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_692_36950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.899 274.152L56.6465 215.811L23.2094 229.151L96.9563 314.769L130.393 301.429L175.905 283.272L226.81 342.371L260.247 329.03L209.342 269.932L238.135 258.444L214.641 231.168L185.848 242.655L135.595 184.314L102.158 197.654L152.411 255.995L106.899 274.152Z",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.78,
    y: 213.868,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.78,
    y: 169.868,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.28 255.492L152.28 255.992L152.28 319.492L107.28 319.492L107.28 255.492Z",
    fill: "#7294FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_692_36950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 397,
    y: 35,
    width: 238,
    height: 159
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.899 125.152L430.647 66.8112L397.209 80.1512L470.956 165.769L504.393 152.429L549.905 134.272L600.81 193.371L634.247 180.03L583.342 120.931L612.135 109.444L588.641 82.1678L559.848 93.655L509.595 35.3138L476.158 48.6538L526.411 106.995L480.899 125.152Z",
    fill: "#4671F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_692_36950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.899 125.152L430.647 66.8112L397.209 80.1512L470.956 165.769L504.393 152.429L549.905 134.272L600.81 193.371L634.247 180.03L583.342 120.931L612.135 109.444L588.641 82.1678L559.848 93.655L509.595 35.3138L476.158 48.6538L526.411 106.995L480.899 125.152Z",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.78,
    y: 64.868,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.78,
    y: 20.868,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.28 106.492L526.28 106.992L526.28 170.492L481.28 170.492L481.28 106.492Z",
    fill: "#7294FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_692_36950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 90,
    width: 303,
    height: 217
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 191,
    transform: "matrix(0.652627 0.757679 -0.92881 0.370557 369.655 90.9333)",
    fill: "#4671F6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_692_36950)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 191,
    transform: "matrix(0.652627 0.757679 -0.92881 0.370557 369.655 90.9333)",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.625,
    y: 85.6695,
    width: 183,
    height: 230,
    fill: "#7294FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.813 45.7587L342.125 41.6698L387.996 278.071L380.222 281.276L334.813 45.7587Z",
    fill: "#474B53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.125 41.6698L334.813 45.7587L380.222 281.276L359.209 289.559L308.125 41.6698Z",
    fill: "#6C6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.974 41.7587L334.813 45.7587L341.879 41.931L314.654 38.0692L307.974 41.7587Z",
    fill: "#858A94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    rx: 4,
    transform: "matrix(0.92388 -0.382683 2.13199e-08 1 226 123.412)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    rx: 4,
    transform: "matrix(0.92388 -0.382683 2.13199e-08 1 236 183.412)",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263 234.912L345.837 201.997C347.855 201.195 349.474 202.305 349.474 204.489C349.474 206.723 347.785 209.223 345.722 210.043L263 242.912L263 234.912Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.8 285.412L355.812 262.052C357.837 261.223 359.474 262.324 359.474 264.516C359.474 266.736 357.797 269.222 355.746 270.041L303.5 290.912L298.8 285.412Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M230.813 83.7587L238.125 79.6698L270.5 252.412L261 241.412L230.813 83.7587Z",
    fill: "#474B53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.125 79.6698L230.813 83.7587L261 241.412L231 206.912L204.125 79.6698Z",
    fill: "#6C6C6C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M203.974 79.7587L230.813 83.7587L238.1 79.7122L210.654 76.0692L203.974 79.7587Z",
    fill: "#858A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.9692c50e36a2f2fdd1b58fb46273286e.svg";
export { ForwardRef as ReactComponent };